import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { Utils } from 'src/app/common/utils/utils';
import { AppGlobal } from 'src/app/core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import { DevicesConstants } from 'src/app/core/routing/services/devices/constants/devices.constants';
import { DeviceStoreService } from '../store/device.store';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-device-idle-experience',
  templateUrl: './device-idle-experience.component.html',
  styleUrls: ['./device-idle-experience.component.scss']
})
export class DeviceIdleExperienceComponent implements OnInit {
  isAttractorLoopRadionBtn: boolean;
  idleDisplayValue: string;
  buttonEnabel: boolean;
  isincreasePromotionRotation: boolean;
  OledContentEnabled : boolean;
  globalconst = GlobalConstants;
  selectedIdleTime: number;
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  buttonLabelNo = DevicesConstants.NO;
  attractLoopData: any;
  isRetailerId: boolean;
  isAttractLoopRecordFound = false;
  @Output() readonly dismissFunc = new EventEmitter();
  @Output() readonly getIdleExpStatus = new EventEmitter();
  selectedAttractLoopId: string;
  retailerConfig: any;
  userRole: any;
  private ngUnsubscribe = new Subject<boolean>();
  userInfo: { email: string; userId: string; firstName: string; lastName: string; retailerName: string; role: string; retailerID: string; storeID: string; storeName: string; location: string; isCompRxtEnabled: boolean; isRemoveEnabled: boolean; isAutoShutdown?: boolean; customSrtEnabled?: boolean; configurations?: string; partnerID?: string; partnerName?: string; };
  isNonConnectedUser: boolean;
  send;
  attractorLoopValue;
  attractloopcontent: { attractLoop: any; };
  successMessage: any;
  description: any;
  isCancel = false;
  openModalPopup = false;
  burnIn = GlobalConstants.BURN_IN_VIDEO;
  includeLogoContent = GlobalConstants.INCLUDE_LOGO_CONTENT;
  includeLogoContentSubstr = GlobalConstants.INCLUDE_LOGO_CONTENT_SUBSTRING;
  includeSegmentContent = GlobalConstants.INCLUDE_SEGMENT_CONTENT;
  includeSegmentContentSubstr = GlobalConstants.INCLUDE_SEGMENT_CONTENT_SUBSTRING;
  oledExperience = GlobalConstants.OLED_EXPERIENCE;
  oledExperienceSubstr = GlobalConstants.OLED_EXPERIENCE_SUBSTR;
  isLogoContentEnabled: boolean;
  isSegmentContentEnabled: boolean;
  isOledContentEnabled: boolean;

  constructor(private appGlobal: AppGlobal, private deviceStore: DeviceStoreService,
    private googleAnalyticsService : GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.googleAnalyticsService.devieInfoTabName('Idle_Experience');
    this.isRetailerId = sessionStorage.getItem('retailerId') !== 'undefined';
    const storeData = this.deviceStore?.deviceStoreData;
    let storeDataObj;
    if(storeData && storeData?.settings) storeDataObj = JSON.parse(storeData?.settings?.toString());
    this.isAttractorLoopRadionBtn =  storeDataObj?.idleExperience?.IdleDisplay == 'AttractLoop'?true:false;
    this.isLogoContentEnabled = storeData?storeDataObj?.idleExperience?.isLogoContentEnabled:false;
    this.isSegmentContentEnabled =  storeData?storeDataObj?.idleExperience?.isSegmentContentEnabled:false;
    this.OledContentEnabled =  (storeData && storeData?.settings) ?storeDataObj?.otherSettings?.isOledContentEnabled:false;
    this.selectedIdleTime = this.OledContentEnabled ? 30 : (storeData && storeData?.settings) ? storeDataObj?.idleExperience?.TimeUntilIdle:120;
    this.isincreasePromotionRotation = (storeData && storeData?.settings) ? storeDataObj?.otherSettings?.increasePromotionRotation :false;
    this.buttonEnabel = true;
    this.idleDisplayValue = GlobalConstants.FACT_TAG_ROTATION_VALUE;
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.userRole = userAccount.role;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.retailerConfig = JSON.parse(userAccount?.configurations);
        }
        this.userInfo = { ...userAccount };
        this.isNonConnectedUser = this.userInfo.role === GlobalConstants.NON_CONNECTED_USER ? true : false;
      });
    this.send = {};
    this.selectedAttractLoopId = this.attractorLoopValue? this.attractorLoopValue : (storeData?.attractLoop ? storeData?.attractLoop['attractLoopId'] : '');
  }

  isPromotionRotation(data) {
    this.buttonEnabel=true;
    this.isAttractorLoopRadionBtn=false;
    this.isLogoContentEnabled=false;
    this.isSegmentContentEnabled=false;
    this.isincreasePromotionRotation = data.currentTarget.checked;
  }
  getAttractLoopRecordCount(data) {
    if (data > 0) this.isAttractLoopRecordFound = true;
  }
  getSelectedAttractLoopData(data) {
    this.buttonEnabel = true;
    if (data?.status) {
      this.attractLoopData = {
        attractLoopId: data?.id,
        showOnDevice: true
      };
    } else {
      this.attractLoopData = {
        showOnDevice: false
      };
    }
  }

  customizableButton(data, element) {
    this.buttonEnabel = true;
    this.isincreasePromotionRotation=false;
    if (element === 'factTag') {
      this.idleDisplayValue = data;
      this.isAttractorLoopRadionBtn = false;
    } else if (element === 'attractloop') {
      this.isLogoContentEnabled=false;
      this.isSegmentContentEnabled=false;
      this.isincreasePromotionRotation = false;
      this.idleDisplayValue = data;
      this.isAttractorLoopRadionBtn = true;
    } else if (element === 'time') {
      this.selectedIdleTime = +data.target.value;
    }
  }
  configData(isAttractorLoop) {
    let jsonData = {
      isBrandColorEnabled: Utils.checkRole(this.userRole) ?
        (this.retailerConfig?.bandColor !== undefined ? this.retailerConfig?.bandColor : false) :
        false,
      brandColor: Utils.checkRole(this.userRole) ?
        (this.retailerConfig?.bgcolor ? this.retailerConfig?.bgcolor : "") : "",
      enable3DMarkFeature: Utils.checkRole(this.userRole) ?
        (this.retailerConfig?.enable3DMarkFeature !== undefined ? this.retailerConfig?.enable3DMarkFeature : false) :
        false,
      enableMobileSocket: GlobalConstants.SOCKET_DEFAULT_VALUE,
      pollFrequency: Utils.checkRole(this.userRole) ?
        (this.retailerConfig?.pollFrequency ? this.retailerConfig?.pollFrequency : GlobalConstants.POLL_FREQ_DEFULT_VALUE) :
        GlobalConstants.POLL_FREQ_DEFULT_VALUE
    };
    if (isAttractorLoop) {
      jsonData['increasePromotionRotation'] = this.isincreasePromotionRotation;
    }
    jsonData['isOledContentEnabled'] = this.OledContentEnabled;
    return jsonData;
  }

  sendDataToStore() {
    if(this.selectedIdleTime == undefined){
      this.selectedIdleTime = 120;
    }
    const payload: any = {
      idleExperience: {
        TimeUntilIdle: this.selectedIdleTime,
        IdleDisplay: this.idleDisplayValue,
        isLogoContentEnabled: (this.idleDisplayValue === GlobalConstants.FACT_TAG_ROTATION_VALUE) ? this.isLogoContentEnabled : false,
        isSegmentContentEnabled: (this.idleDisplayValue === GlobalConstants.FACT_TAG_ROTATION_VALUE) ? this.isSegmentContentEnabled : false,
        },
      otherSettings: this.configData(true)
    };
    this.isCancel = false;
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    this.send = { settings: JSON.stringify(payload) };
    this.deviceStore.updateDeviceData(this.send);
    if(this.attractorLoopValue?.attractLoopId) {
      this.selectedAttractLoopId = this.attractLoopData.attractLoopId;
    }
    if (this.isAttractorLoopRadionBtn) {
      const payload: any = this.attractLoopData
      this.attractloopcontent = { attractLoop: (payload) };
      if(payload) {
        this.deviceStore.updateDeviceData(this.attractloopcontent);
      }
    }
    this.getIdleExpStatus.emit(true);
    this.googleAnalyticsService.devieInfoChangesSaved('Idle_Experience');
  }

  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  closeModal() {
    this.openModalPopup = false;
  }
  
  isLogoContent(data) {
    this.isLogoContentEnabled = data.currentTarget.checked;
  }
  
  isSegmentContent(data) {
    this.isSegmentContentEnabled = data.currentTarget.checked;
  }    

  isOledContent(data) {
    this.OledContentEnabled = data.currentTarget.checked;
    this.selectedIdleTime = this.OledContentEnabled ? 30 :120;
  }    
}
